import { Pipe, PipeTransform } from '@angular/core';
import { VISA_REQUIREMENT } from '@univacity/shared/types';
import { Observable, of } from 'rxjs';
import { VisaInfoService } from '../services';

@Pipe({
  name: 'visaRequirement',
  standalone: true,
})
export class VisaRequirementPipe implements PipeTransform {
  constructor(private service: VisaInfoService) {}

  transform(
    country?: string,
    citizen?: string
  ): Observable<{ requirement: VISA_REQUIREMENT } | null> {
    if (!country || !citizen) return of(null);
    return this.service.getVisaRequirement(country, citizen);
  }
}
